import React from 'react';
import AiHome from './AiHome';

/**
 * Live 改善相談 flow — AiHome with improve banner + 実践メモ cards.
 * Static Kuroco mock retired; AI drives ACTIONS + PRACTICE_MEMO.
 */
export default function AiImprove(props) {
  return <AiHome {...props} initialFlow="improve" />;
}
